'use client';

import clsx from 'clsx';
import React, { ChangeEvent, InputHTMLAttributes, useRef, useState } from 'react';

import EyeIcon from '@/icons/EyeIcon';
import XCircle from '@/icons/XCircle';
import { cn } from '@/utils/twx';
import { isPasswordKey } from '@/utils/validation';

import Input from '../Input';

interface PasswordInputProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  clear?: () => void;
}

export const PasswordInput = ({ id, value, onChange, clear, ...props }: PasswordInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
    inputRef.current?.focus();
    setTimeout(() => {
      inputRef.current?.setSelectionRange(value.length, value.length);
    }, 0);
  };

  const handleClear = () => {
    if (clear) {
      clear();
    }
    inputRef.current?.focus();
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (value) {
      if (!isPasswordKey(value)) {
        alert('비밀번호는 영문, 숫자, 특수문자만 입력할 수 있습니다');
        return;
      }
    }
    onChange(e);
  };

  return (
    <div className="w-full">
      <div className="relative">
        <Input
          {...props}
          type={showPassword ? 'text' : 'password'}
          id={id}
          value={value}
          onChange={handleChange}
          className={cn('pr-16 w-full', props.className ?? '')}
          ref={inputRef}
        />
        {value && (
          <div className="absolute right-10 top-4">
            <div className="text-gray-4 cursor-pointer" onClick={handleClear}>
              <XCircle color="gray" />
            </div>
          </div>
        )}
        {value !== '' && (
          <div
            className="absolute right-3 top-4 text-gray-4 cursor-pointer"
            onClick={toggleShowPassword}
          >
            <EyeIcon className={clsx('transition-all', showPassword ? '' : 'text-gray-5')} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PasswordInput;
